<template lang="pug">
	div.container
		h3 v1.0-beta03.01 (27-04-2019)
		ul 
			li Исправлена ошибка со сбросом фокуса при вводе теста.
		
		h3 v1.0-beta03 (25-04-2019)
		ul 
			li Исправлено отображение последних номеров в панели.
			li Добавлена возможность перетаскивать (менять местами) пункты в меню.
			li Исправлено отображение подсказок.

		h3 v1.0-beta02 (16-04-2019)
		ul 
			li Объединены страницы "главная" и "редактирование".
			li Имена меню теперь могут содержать цифры и нижнее подчёркивание.
			li Добавлена проверка правильности ввода команды.
			li Добавлена возможность выполнять команду после входа игрока.
			li Добавлено экранирование заголовка плагина.

		h3 v1.0-beta01 (12-04-2019)
		ul
			li Jumbotron заменён на navbar. 
			li Добавлены заготовки раздела "список изменений" и "примеры". 
			li Небольшие изменения в дизайне. 
			li Добавлена возможность импорта\экспорта настроек в JSON-формате. 
			li Добавлено экранирование кавычек и процентов в тексте и командах. 
			li Новое меню создается с одним пустым пунктом. 
			li Добавлена английская версия сайта. 
			li Исправлен предпросмотр для активных пунктов с 2+ строками. 
			li Добавлены правила ввода имён меню. 
			li Добавлен поиск по существующим меню для кнопки назад и для действия открытия меню.
			
		h3 v1.0-beta (08-04-2019)
		ul
			li Публичный релиз. 
</template>

<script>
export default {
	name: "changelog",
}
</script>
